module.exports = __webpack_public_path__ + "static/media/masraf_genel_yardim.c1074e34.pdf";